import React, {useEffect, useState} from "react";
import MachineFormatParts from "./MachineFormatParts";
import PartType from "./part/PartType";
import {Actions} from "../../../client/Actions";
import PartTextField from "./part/PartTextField";
import { useTranslation } from 'react-i18next';

const FormatCreationMachineFormatParts = ({
                                              format,
                                              machineModel,
                                              setLoader,
                                              reload,
                                              configurations,
                                              setConfigurations,
                                              additionalColumns,
                                              externalConfigs,
                                              withHeader,
                                              checkAllByDefault = false,
                                              readOnly
                                          }) => {

        const { t } = useTranslation();
        const [checked, setChecked] = useState([])
        const [partTypes, setPartTypes] = useState([])

        useEffect(() => {
            if (!readOnly) {

                setConfigurations((prevConfigurations) => {
                    let updatedConfigurations = [...prevConfigurations];

                    checked.forEach((checkedItem) => {
                        if (!updatedConfigurations.some(config => config.formatPart.id === checkedItem.id)) {
                            updatedConfigurations.push({formatPart: {id: checkedItem.id}});
                        }
                    });

                    updatedConfigurations = updatedConfigurations.filter(config =>
                        checked.some(checkedItem => checkedItem.id === config.formatPart.id)
                    );

                    return updatedConfigurations;
                });
            }
        }, [checked]);


        useEffect(() => {
            if (readOnly) {
                setChecked(configurations.map(c => c.formatPart.id))
            }
        }, [configurations]);


        useEffect(() => {
            Actions.get("enums/partType", setPartTypes)
        }, []);


        const partTypeColumn = {
            field: "partType",
            label: t("common.kind"),
            sort: "desc",
            width: 200,
            type: "custom",
            custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState, externalState2) {
                return (<PartType
                    formatPart={row}
                    readOnly={readOnly}
                    configurations={externalState}
                    setConfigurations={setConfigurations}
                    partTypes={externalState2}
                />)
            }

        }

        const partCommentColumn = {
            field: "partComment",
            label: t("common.comment"),
            sort: "desc",
            width: 200,
            type: "custom",
            custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
                return (<PartTextField
                    formatPart={row}
                    readOnly={readOnly}
                    configurations={externalState}
                    setConfigurations={setConfigurations}
                    fieldName={"label"}
                />)
            }

        }

        const partNumberColumn = {
            field: "partNumber",
            label: t("common.number"),
            sort: "desc",
            width: 200,
            type: "custom",
            custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
                return (<PartTextField
                    formatPart={row}
                    readOnly={readOnly}
                    configurations={externalState}
                    setConfigurations={setConfigurations}
                    fieldName={"partNumber"}
                />)
            }

        }


        const partPositionColumn = {
            field: "position",
            label: t("common.position"),
            sort: "desc",
            width: 200,
            type: "custom",
            custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
                return (<PartTextField
                    formatPart={row}
                    readOnly={readOnly}
                    configurations={externalState}
                    setConfigurations={setConfigurations}
                    fieldName={"position"}
                />)
            }

        }

        const checkedColumn = {
            field: "check",
            label: t("forms.in_format"),
            sort: "desc",
            width: 200,
            type: "checkbox"
        }


        return (
            <>
                {partTypes &&
                    <MachineFormatParts
                        format={format}
                        machine={machineModel}
                        setLoader={setLoader}
                        reload={reload}
                        readOnly={readOnly}
                        withHeader={withHeader}
                        checkAllByDefault={checkAllByDefault}
                        externalConfigs={externalConfigs}
                        checked={checked}
                        setChecked={setChecked}
                        additionalColumns={additionalColumns || [checkedColumn, partTypeColumn, partNumberColumn, partPositionColumn, partCommentColumn]}
                        configurations={configurations}
                        externalConfigs2={partTypes}
                        setConfigurations={setConfigurations}
                    />
                }

            </>
        );
    }
;


export default FormatCreationMachineFormatParts;